import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Package } from "lucide-react";
 * // Use <Package /> instead
 */
export const ProductsIcons = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.1567 4.52715C13.0959 4.53253 12.0807 4.95909 11.3344 5.713L3.74994 13.3744C2.78204 14.3522 2.78602 15.9282 3.75884 16.901L7.27936 20.4215C8.26496 21.4071 9.86623 21.3964 10.8385 20.3976L18.3662 12.6647C19.0932 11.9179 19.5 10.9168 19.5 9.87459L19.5 6.00766C19.5 5.17626 18.8237 4.50346 17.9923 4.50768L14.1567 4.52715ZM15 10.5C15.8284 10.5 16.5 9.82843 16.5 9C16.5 8.17157 15.8284 7.5 15 7.5C14.1716 7.5 13.5 8.17157 13.5 9C13.5 9.82843 14.1716 10.5 15 10.5Z"
  />
);
